import React from "react";
import {Box, Colors, Text} from "@bounce/shared/ui";
import {TextField} from "../../../../ui/components";
import {BaseValueInputProps} from "./types";

const TextValueInput: React.FC<BaseValueInputProps> = ({value, valueError, onChange, showLabel = true}) => (
  <Box sx={{flex: 2}}>
    {showLabel && (
      <Text size={12} sx={{color: Colors.grey._700, mb: 0.5}}>
        Value
      </Text>
    )}
    <TextField
      size="small"
      fullWidth
      placeholder="Value"
      value={typeof value === "string" ? value : ""}
      onChange={(e) => onChange(e.target.value)}
      error={!!valueError}
    />
  </Box>
);

export default TextValueInput;
